import React, { useEffect, useState } from 'react';
import { fetchOrders } from '../../../services/orderApi';

const RecentOrders = () => {
  const [sortOrder, setSortOrder] = useState({
    column: null,
    direction: 'asc',
  });

  console.log(sortOrder);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const params = new URLSearchParams({
          page: '1',
          limit: '8',
          sortBy: 'createdAt',
          sortOrder: 'desc',
        });
        const { orders } = await fetchOrders(params);
        const fmt = (d) =>
          new Date(d).toLocaleDateString(undefined, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          });
        const r = (orders || []).slice(0, 8).map((o) => ({
          id: o.orderNumber || `#${o.id}`,
          productName: o.items?.[0]?.productName || 'Order Items',
          date: o.createdAt ? fmt(o.createdAt) : '-',
          price:
            typeof o.totalAmount === 'number'
              ? `$${o.totalAmount.toFixed(2)}`
              : '$0.00',
          status: (o.status || 'processing')
            .replace(/_/g, ' ')
            .replace(/^\w/, (c) => c.toUpperCase()),
          statusColor:
            o.status === 'cancelled' || o.status === 'failed'
              ? 'bg-red-500'
              : o.status === 'delivered' || o.status === 'completed'
                ? 'bg-green-500'
                : 'bg-yellow-500',
        }));
        if (mounted) setRows(r);
      } catch (_) {
        if (mounted)
          setRows([
            {
              id: '#13102006',
              productName: 'Professional Paint Brush Set',
              date: '19 Nov 2023',
              price: '$213.00',
              status: 'Confirmed',
              statusColor: 'bg-green-500',
            },
            {
              id: '#20071909',
              productName: 'Safety Work Jacket',
              date: '13 Nov 2023',
              price: '$367.00',
              status: 'Canceled',
              statusColor: 'bg-red-500',
            },
            {
              id: '#131920167',
              productName: 'Industrial Primer',
              date: '7 Nov 2023',
              price: '$126.00',
              status: 'Confirmed',
              statusColor: 'bg-green-500',
            },
          ]);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSort = (column) => {
    setSortOrder((prev) => ({
      column,
      direction:
        prev.column === column && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const SortIcon = () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.5L6 1.5L9 4.5"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.5L6 10.5L9 7.5"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div
      className="bg-white rounded-[12px] p-4 sm:p-6"
      style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
    >
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-6">
        <div>
          <h2 className="text-[#373737] poppins text-[18px] sm:text-[20px] lg:text-[24px] leading-[27px] sm:leading-[30px] lg:leading-[36px] tracking-[-0.96px] font-bold mb-1">
            Recent Order
          </h2>
          <p className="text-[#9CA3AF] poppins text-[12px] sm:text-[14px] leading-[18px] sm:leading-[21px] tracking-[-0.56px]">
            Your sales statistic report
          </p>
        </div>
        <button className="flex items-center gap-2 border border-[#E5E7EB] bg-white rounded-[8px] px-3 sm:px-4 py-2 text-[#6B7280] text-[12px] sm:text-[14px] font-medium poppins hover:bg-gray-50 transition-colors self-start sm:self-auto">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 4H14M4 8H12M6 12H10"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          Filter
        </button>
      </div>

      {/* Table */}
      <div className="bg-[#F9FAFB] rounded-[8px] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="bg-[#F3F4F6]">
                <th
                  className="px-3 sm:px-6 py-3 sm:py-4 text-left cursor-pointer hover:bg-[#E5E7EB] transition-colors"
                  onClick={() => handleSort('orderId')}
                >
                  <div className="flex items-center gap-1 sm:gap-2">
                    <span className="text-[#6B7280] poppins text-[10px] sm:text-[12px] leading-[15px] sm:leading-[18px] tracking-[-0.48px] font-medium uppercase">
                      Order ID
                    </span>
                    <SortIcon />
                  </div>
                </th>
                <th
                  className="px-3 sm:px-6 py-3 sm:py-4 text-left cursor-pointer hover:bg-[#E5E7EB] transition-colors"
                  onClick={() => handleSort('productName')}
                >
                  <div className="flex items-center gap-1 sm:gap-2">
                    <span className="text-[#6B7280] poppins text-[10px] sm:text-[12px] leading-[15px] sm:leading-[18px] tracking-[-0.48px] font-medium uppercase">
                      Product Name
                    </span>
                    <SortIcon />
                  </div>
                </th>
                <th
                  className="px-3 sm:px-6 py-3 sm:py-4 text-left cursor-pointer hover:bg-[#E5E7EB] transition-colors"
                  onClick={() => handleSort('date')}
                >
                  <div className="flex items-center gap-1 sm:gap-2">
                    <span className="text-[#6B7280] poppins text-[10px] sm:text-[12px] leading-[15px] sm:leading-[18px] tracking-[-0.48px] font-medium uppercase">
                      Date
                    </span>
                    <SortIcon />
                  </div>
                </th>
                <th
                  className="px-3 sm:px-6 py-3 sm:py-4 text-left cursor-pointer hover:bg-[#E5E7EB] transition-colors"
                  onClick={() => handleSort('price')}
                >
                  <div className="flex items-center gap-1 sm:gap-2">
                    <span className="text-[#6B7280] poppins text-[10px] sm:text-[12px] leading-[15px] sm:leading-[18px] tracking-[-0.48px] font-medium uppercase">
                      Price
                    </span>
                    <SortIcon />
                  </div>
                </th>
                <th
                  className="px-3 sm:px-6 py-3 sm:py-4 text-left cursor-pointer hover:bg-[#E5E7EB] transition-colors"
                  onClick={() => handleSort('status')}
                >
                  <div className="flex items-center gap-1 sm:gap-2">
                    <span className="text-[#6B7280] poppins text-[10px] sm:text-[12px] leading-[15px] sm:leading-[18px] tracking-[-0.48px] font-medium uppercase">
                      Status
                    </span>
                    <SortIcon />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((order, index) => (
                <tr
                  key={order.id}
                  className="border-b border-[#E5E7EB] last:border-b-0 hover:bg-white transition-colors"
                >
                  <td className="px-6 py-4">
                    <span className="text-[#374151] poppins text-[14px] leading-[21px] tracking-[-0.56px] font-medium">
                      {order.id}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-[#F3F4F6] rounded-[4px] flex items-center justify-center">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 2H2C1.45 2 1 2.45 1 3V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V3C15 2.45 14.55 2 14 2ZM13 12H3V4H13V12Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M5 6H11V7H5V6ZM5 8H11V9H5V8ZM5 10H9V11H5V10Z"
                            fill="#9CA3AF"
                          />
                        </svg>
                      </div>
                      <span className="text-[#374151] poppins text-[14px] leading-[21px] tracking-[-0.56px] font-medium">
                        {order.productName}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-[#6B7280] poppins text-[14px] leading-[21px] tracking-[-0.56px]">
                      {order.date}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-[#374151] poppins text-[14px] leading-[21px] tracking-[-0.56px] font-medium">
                      {order.price}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-[12px] leading-[18px] font-medium poppins text-white ${order.statusColor}`}
                    >
                      {order.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecentOrders;
